import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { ShowIfPermittedDirective } from 'src/app/module/order-list/directives/show-if-permitted.directive';
import { AppPermission } from 'src/app/shared/interface/common.interface';
import { UserState } from 'src/app/shared/state/user.state';

@Component({
  selector: 'app-not-found-page',
  standalone: true,
  imports: [MatButtonModule, ShowIfPermittedDirective, MatIconModule],
  templateUrl: './not-found-page.component.html',
  styleUrl: './not-found-page.component.scss',
})
export class NotFoundPageComponent {
  permission = AppPermission;

  constructor(
    public router: Router,
    public userState: UserState
  ) {}
}
